import fetch from "@/utils/fetch";
import "@/types/notificationMailRecipients";

const BASE = "/api/notification/mail-recipients";

export default {
  /**
   * @returns {Promise<MailRecipientDto[]>}
   */
  async getList() {
    const res = await fetch.get(`${BASE}/get-list`);
    if (Array.isArray(res)) return res;
    if (res && Array.isArray(res.content)) return res.content;
    if (res && Array.isArray(res.items)) return res.items;
    return [];
  },

  /**
   * @param {MailRecipientDto} payload
   * @returns {Promise<number|boolean|undefined>}
   */
  async save(payload) {
    return await fetch.post(`${BASE}/save`, payload);
  },

  /**
   * @param {number} id
   * @returns {Promise<boolean|undefined>}
   */
  async delete(id) {
    return await fetch.post(`${BASE}/delete?id=${id}`);
  }
};
